import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Connects to data-controller="portfolios--links--create"
export default class extends Controller {
  static targets = ["loader", "form", "formField"];

  static values = {
    accessToken: String,
    modalId: String,
    isNative: Boolean
  }

  connect() {
    this.loaderTarget.remove();
    this.openFastlink();
  }

  cancel() {
    this.closeFastlink();
    this.closeModal();
  }

  closeFastlink() {
    window.fastlink.close();
  }

  closeModal() {
    this.modal().hide();
  }

  config() {
    let params = {
      configName: 'aggregation'
    };

    if (this.isNativeValue) {
      params.intentUrl = 'fuchsapp://fastlink/callback';
      params.isIFrameMounted = true;
    }

    return {
      fastLinkURL: 'https://finapp.fingoalchannel.yodlee.com/authenticate/fuchsfinancial-production/fastlink?channelAppName=fingoalchannel',
      accessToken: `Bearer ${this.accessTokenValue}`,
      params: params,
      onSuccess: this.onSuccess.bind(this),
      onError: (data) => {
        Honeybadger.notify("portfolios--links--create :: onError :: ", data);
        console.log("onError", data);
      },
      onClose: (data) => {
        console.log("portfolios--links--create :: onClose :: ", data);
        this.closeModal();
      },
      onEvent: (data) => {
        console.log("portfolios--links--create :: onEvent :: ", data);
      }
    }
  }

  modal() {
    return Modal.getOrCreateInstance(`#${this.modalIdValue}`);
  }

  openFastlink() {
    let result;
    console.log("opening fastlink ...........");
    try {
      result = window.fastlink.open(
        this.config(),
        "portfolios_links_create_embed"
      );
    }
    catch (e) {
      console.log("Error opening Fastlink ::::::::::::", e.message);
    }
    console.log("result ::::::::::::::", result);
  }

  onSuccess(data) {
    /*
      {
        "providerId": 19335,
        "providerName": "Dag OAuth",
        "requestId": "5jJMeWG2RWmxLtNlOScqYynBmBY=",
        "status": "SUCCESS",
        "additionalStatus": "ACCT_SUMMARY_RECEIVED",
        "providerAccountId": 11343698,
        "fnToCall": "accountStatus"
      }
    */
    console.log("portfolios--links--create :: onSuccess :: ", data, this.element, this.formFieldTarget);
    this.formFieldTarget.value = JSON.stringify(data);
    this.formTarget.requestSubmit();
  }

  restart() {
    this.closeFastlink();
    this.openFastlink();
  }
}
